import { YearFilterState } from './year.types';

export const getDefaultYearsFilter = (): YearFilterState => ({
  selectedYears: {
    0: true,
  },
});
export const defaultYearsFilter = getDefaultYearsFilter();
